<template>
  <div class="nch--blog-post header" :style="`--category-color: ${post.category.color}`">
    <img class="nch--blog-post featured-image" v-if="image" :src="image" alt="">
    <h2 class="nch--blog-title">{{ post.translation.title }}</h2>
    <div class="meta">
      {{ $t('blog.posts.by') }} <strong>{{ post.author.name }}</strong>
      &middot;
      {{ $moment(post.created_at).format('LL') }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    value: {
      type: Object,
      description: 'Post object',
      required: true,
    },
  },
  computed: {
    post() {
      return this.value;
    },
    image() {
      if (this.post.featured_image) {
        const url = this.getImageUrl(this.post.featured_image);
        return url;
      } else if (this.post.category.featured_image) {
        const url = this.getImageUrl(this.post.category.featured_image);
        return url;
      }
      return null;
    },
  },
  methods: {
    getImageUrl(upload) {
      const { host, original_file: file } = upload;
      return `/storage/${host}/original/${file}`;
    },
  },
};
</script>

<style scoped>

.nch--blog-post.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;

  justify-content: center;
  align-items: center;
}
.nch--blog-post.header::after{
  content: "";
  display: flex;
  align-self: flex-start;
  width: 30%;
  height: .2rem;
  background-color: var(--category-color);
}
.nch--blog-post.header h2.nch--blog-title {
  color: var(--blog-text);
  word-break: break-word;
  font-size: 2.5rem;
  text-align: left;
  width: 100%;
  line-height: 1.1;
  margin-top: 1rem;
}
.nch--blog-post.featured-image{
  max-height: 400px;
  width: 100%;
  max-width: 728px;
  object-fit: cover;
  object-position: center;
  border-radius: 5px;
}
.nch--blog-post .meta {
  width: 100%;
  font-size: .9rem;
  margin-bottom: .1rem;
}
@media (max-width: 900px) {
  .nch--blog-post.header h2.nch--blog-title {
    font-size: 2rem;
  }
  .nch--blog-post .meta {
    font-size: .8rem;
  }
}
</style>
